/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */

import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';

import { CONCLUDE_CONTRACT_SIGNATURE_REQUEST, success, failure } from './action';

const events = (action$, state$, { AjaxRequest }) =>
  action$
    .ofType(CONCLUDE_CONTRACT_SIGNATURE_REQUEST)
    .map(({ payload }) => payload)
    .mergeMap((id) =>
      AjaxRequest.open(
        'post',
        `/admin/contractcustom/contracts/${id}/concludecontractsignature`,
        {},
      )('tudo')
        .flatMap(({ response }) => Observable.of(success(response.resource)))
        .catch((err) => Observable.of(failure(err))),
    );

export default combineEpics(events);
